import dayjs from 'dayjs';

export const calculateTimeRange = (currentPeriod: dayjs.Dayjs, period: string) => {
  let startDate;
  let endDate;

  switch (period) {
    case 'Semanal':
      startDate = currentPeriod.startOf('week');
      endDate = currentPeriod.endOf('week');
      break;
    case 'Mensal':
      startDate = currentPeriod.startOf('month');
      endDate = currentPeriod.endOf('month');
      break;
    case 'Trimestral':
      startDate = currentPeriod.startOf('quarter');
      endDate = currentPeriod.endOf('quarter');
      break;
    case 'Semestral':
      startDate = currentPeriod.month() < 6 ? currentPeriod.startOf('year') : currentPeriod.startOf('year').add(6, 'months');
      endDate = startDate.add(5, 'months').endOf('month');
      break;
    case 'Anual':
      startDate = currentPeriod.startOf('year');
      endDate = currentPeriod.endOf('year');
      break;
    default:
      startDate = currentPeriod.startOf('week');
      endDate = currentPeriod.endOf('week');
  }

  return { startDate, endDate };
};